/** Message catalogue for features/catalog (merged into the global catalogues). Keys: "cat.<area>.<name>". */
import { catRecordEn, catRecordHi } from './record/messages';
import { catEditorEn, catEditorHi } from './editor/messages';

export const catEn = {
  'cat.eyebrow': 'Catalogue',
  'cat.nav.import': 'Import',
  'cat.nav.new': 'New record',
  'cat.search.title': 'Search the catalogue',
  'cat.search.description': 'Find titles by keyword, author, ISBN, subject or barcode.',
  'cat.search.label': 'Search the catalogue',
  'cat.search.placeholder': 'Search titles, authors, subjects, ISBN',
  'cat.search.scanPlaceholder': 'Scan or type an item barcode',
  'cat.search.fieldGroup': 'Search in',
  'cat.search.announce': '{n} results',
  'cat.search.barcodeMissing': 'No item has the barcode {barcode}.',
  'cat.search.keyHint': 'Keys: / search, j and k move, Enter opens a record.',
  'cat.field.any': 'Keyword',
  'cat.field.title': 'Title',
  'cat.field.author': 'Author',
  'cat.field.isbn': 'ISBN',
  'cat.field.subject': 'Subject',
  'cat.field.series': 'Series',
  'cat.field.callnumber': 'Call number',
  'cat.field.barcode': 'Barcode',
  'cat.facet.title': 'Refine results',
  'cat.facet.itemType': 'Item type',
  'cat.facet.library': 'Library',
  'cat.facet.language': 'Language',
  'cat.facet.subject': 'Subject',
  'cat.facet.author': 'Author',
  'cat.facet.decade': 'Decade',
  'cat.facet.collection': 'Collection',
  'cat.facet.more': 'Show {n} more',
  'cat.facet.less': 'Show fewer',
  'cat.facet.availableNow': 'Available now',
  'cat.facet.availableNowHint': 'Only titles with a copy on the shelf',
  'cat.filters.active': 'Active filters',
  'cat.filters.remove': 'Remove filter {name}',
  'cat.results.title': 'Search results',
  'cat.results.count': '{n} results for {q}',
  'cat.results.allRecords': 'all records',
  'cat.results.didYouMean': 'Did you mean',
  'cat.results.emptyTitle': 'No records match',
  'cat.results.emptyHint': 'Try fewer words, another search field, or remove a filter.',
  'cat.results.reset': 'Clear search and filters',
  'cat.sort.label': 'Sort results',
  'cat.sort.relevance': 'Relevance',
  'cat.sort.titleAz': 'Title A to Z',
  'cat.sort.titleZa': 'Title Z to A',
  'cat.sort.author': 'Author',
  'cat.sort.yearOld': 'Year, oldest first',
  'cat.sort.yearNew': 'Year, newest first',
  'cat.sort.newest': 'Recently added',
  'cat.sort.popular': 'Most borrowed',
  'cat.view.label': 'Result layout',
  'cat.view.list': 'List view',
  'cat.view.grid': 'Grid view',
  'cat.saved.title': 'Saved searches',
  'cat.saved.name': 'Name this search',
  'cat.saved.empty': 'Run a search, then save it here to reuse the query and filters.',
  'cat.saved.remove': 'Remove saved search {name}',
  'cat.recent.title': 'Recently catalogued',
  'cat.recent.emptyTitle': 'The catalogue is empty',
  'cat.recent.emptyHint': 'Create a record or import MARC to get started.',
  'cat.avail.noCopies': 'No copies',
  'cat.avail.some': '{available} of {total} available',
  'cat.avail.allOut': 'All {total} on loan',
  'cat.avail.none': '{total} not available',
  'cat.badge.suppressed': 'Suppressed',
  'cat.badge.serial': 'Serial',
  'cat.action.more': 'More actions',
  'cat.action.hold': 'Place hold',
  'cat.action.addItem': 'Add item',
  'cat.action.addToList': 'Add to list',
  'cat.action.viewMarc': 'View MARC',
  'cat.action.edit': 'Edit record',
  'cat.hold.title': 'Place a hold',
  'cat.hold.patron': 'Patron',
  'cat.hold.pickup': 'Pickup library',
  'cat.hold.place': 'Place hold',
  'cat.hold.confirmAnyway': 'Place hold anyway',
  'cat.hold.placed': 'Hold placed',
  'cat.hold.position': 'Position {n} in the queue',
  'cat.list.addTitle': 'Add to a list',
  'cat.list.choose': 'List',
  'cat.list.add': 'Add to list',
  'cat.list.added': 'Added to the list',
  'cat.list.none': 'You have no lists yet',
  'cat.list.noneHint': 'Create one under Lists, then add records to it from here.',
  ...catRecordEn,
  ...catEditorEn,
} as const;

export const catHi: Record<keyof typeof catEn, string> = {
  'cat.eyebrow': 'सूची',
  'cat.nav.import': 'आयात',
  'cat.nav.new': 'नया रिकॉर्ड',
  'cat.search.title': 'सूची में खोजें',
  'cat.search.description': 'कीवर्ड, लेखक, ISBN, विषय या बारकोड से शीर्षक खोजें।',
  'cat.search.label': 'सूची में खोजें',
  'cat.search.placeholder': 'शीर्षक, लेखक, विषय, ISBN खोजें',
  'cat.search.scanPlaceholder': 'आइटम बारकोड स्कैन करें या लिखें',
  'cat.search.fieldGroup': 'इसमें खोजें',
  'cat.search.announce': '{n} परिणाम',
  'cat.search.barcodeMissing': 'बारकोड {barcode} वाला कोई आइटम नहीं मिला।',
  'cat.search.keyHint': 'कुंजियाँ: / खोज, j और k चलाएँ, Enter रिकॉर्ड खोलता है।',
  'cat.field.any': 'कीवर्ड',
  'cat.field.title': 'शीर्षक',
  'cat.field.author': 'लेखक',
  'cat.field.isbn': 'ISBN',
  'cat.field.subject': 'विषय',
  'cat.field.series': 'श्रृंखला',
  'cat.field.callnumber': 'कॉल नंबर',
  'cat.field.barcode': 'बारकोड',
  'cat.facet.title': 'परिणाम सीमित करें',
  'cat.facet.itemType': 'आइटम प्रकार',
  'cat.facet.library': 'पुस्तकालय',
  'cat.facet.language': 'भाषा',
  'cat.facet.subject': 'विषय',
  'cat.facet.author': 'लेखक',
  'cat.facet.decade': 'दशक',
  'cat.facet.collection': 'संग्रह',
  'cat.facet.more': '{n} और दिखाएँ',
  'cat.facet.less': 'कम दिखाएँ',
  'cat.facet.availableNow': 'अभी उपलब्ध',
  'cat.facet.availableNowHint': 'केवल वे शीर्षक जिनकी प्रति शेल्फ़ पर है',
  'cat.filters.active': 'सक्रिय फ़िल्टर',
  'cat.filters.remove': 'फ़िल्टर {name} हटाएँ',
  'cat.results.title': 'खोज परिणाम',
  'cat.results.count': '{q} के लिए {n} परिणाम',
  'cat.results.allRecords': 'सभी रिकॉर्ड',
  'cat.results.didYouMean': 'क्या आपका मतलब था',
  'cat.results.emptyTitle': 'कोई रिकॉर्ड मेल नहीं खाता',
  'cat.results.emptyHint': 'कम शब्द आज़माएँ, दूसरा खोज क्षेत्र चुनें या कोई फ़िल्टर हटाएँ।',
  'cat.results.reset': 'खोज और फ़िल्टर साफ़ करें',
  'cat.sort.label': 'परिणाम क्रमबद्ध करें',
  'cat.sort.relevance': 'प्रासंगिकता',
  'cat.sort.titleAz': 'शीर्षक अ से ज्ञ',
  'cat.sort.titleZa': 'शीर्षक ज्ञ से अ',
  'cat.sort.author': 'लेखक',
  'cat.sort.yearOld': 'वर्ष, सबसे पुराना पहले',
  'cat.sort.yearNew': 'वर्ष, सबसे नया पहले',
  'cat.sort.newest': 'हाल ही में जोड़े गए',
  'cat.sort.popular': 'सबसे अधिक उधार लिए गए',
  'cat.view.label': 'परिणाम का रूप',
  'cat.view.list': 'सूची दृश्य',
  'cat.view.grid': 'ग्रिड दृश्य',
  'cat.saved.title': 'सहेजी गई खोजें',
  'cat.saved.name': 'इस खोज का नाम',
  'cat.saved.empty': 'खोज चलाएँ, फिर उसे यहाँ सहेजें ताकि क्वेरी और फ़िल्टर दोबारा उपयोग हो सकें।',
  'cat.saved.remove': 'सहेजी गई खोज {name} हटाएँ',
  'cat.recent.title': 'हाल में सूचीबद्ध',
  'cat.recent.emptyTitle': 'सूची खाली है',
  'cat.recent.emptyHint': 'शुरू करने के लिए रिकॉर्ड बनाएँ या MARC आयात करें।',
  'cat.avail.noCopies': 'कोई प्रति नहीं',
  'cat.avail.some': '{total} में से {available} उपलब्ध',
  'cat.avail.allOut': 'सभी {total} उधार पर',
  'cat.avail.none': '{total} उपलब्ध नहीं',
  'cat.badge.suppressed': 'छिपा हुआ',
  'cat.badge.serial': 'धारावाहिक',
  'cat.action.more': 'और क्रियाएँ',
  'cat.action.hold': 'होल्ड लगाएँ',
  'cat.action.addItem': 'आइटम जोड़ें',
  'cat.action.addToList': 'सूची में जोड़ें',
  'cat.action.viewMarc': 'MARC देखें',
  'cat.action.edit': 'रिकॉर्ड संपादित करें',
  'cat.hold.title': 'होल्ड लगाएँ',
  'cat.hold.patron': 'सदस्य',
  'cat.hold.pickup': 'पिकअप पुस्तकालय',
  'cat.hold.place': 'होल्ड लगाएँ',
  'cat.hold.confirmAnyway': 'फिर भी होल्ड लगाएँ',
  'cat.hold.placed': 'होल्ड लगा दिया गया',
  'cat.hold.position': 'कतार में स्थान {n}',
  'cat.list.addTitle': 'सूची में जोड़ें',
  'cat.list.choose': 'सूची',
  'cat.list.add': 'सूची में जोड़ें',
  'cat.list.added': 'सूची में जोड़ा गया',
  'cat.list.none': 'अभी आपकी कोई सूची नहीं है',
  'cat.list.noneHint': 'सूचियाँ में एक बनाएँ, फिर यहाँ से रिकॉर्ड जोड़ें।',
  ...catRecordHi,
  ...catEditorHi,
};
